export default "/images/128f34bd5dc54bdfccffe9c88dbcb0cf.avif";